export type PdfGeneratorConfig = {
  headerPath: string;
  footerPath: string;
};

export type GeneratePdfFileArgs = {
  html: string;
  displayHeaderFooter?: boolean;
  header?: string;
  footer?: string;
};
